import { FunctionComponent } from "react";
import Animated, { AnimateProps } from "react-native-reanimated";

type CreateAnimatedComponentOptions<P> = {
  setNativeProps: (ref: any, props: P) => void;
};

export function createAnimatedComponent<P extends object>(
  component: FunctionComponent<P>,
  options?: CreateAnimatedComponentOptions<P>,
): FunctionComponent<AnimateProps<P>> {
  return Animated.createAnimatedComponent(component, options);
}
